import * as React from 'react'

const SvgFolderIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.981 3.75L9.12 5.881l.362.369H17.5v10h-15V3.75h4.481zm0-1.25H2.5c-.69 0-1.25.56-1.25 1.25v12.5c0 .69.56 1.25 1.25 1.25h15c.69 0 1.25-.56 1.25-1.25v-10c0-.69-.56-1.25-1.25-1.25H10L7.869 2.869A1.25 1.25 0 006.98 2.5z"
      fill="#163250"
    />
  </svg>
)

export default SvgFolderIcon
